import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({
    title: "Page introuvable | My Animation",
    description: "Cette page n'existe pas ou a été déplacée.",
    path: "/404",
    noindex: true,
  });
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-32" data-testid="not-found">
      <div className="text-center max-w-xl">
        <p className="eyebrow">Erreur 404</p>
        <h1 className="font-serif-luxe text-6xl md:text-8xl mt-4">
          Page <span className="italic gold-text">introuvable.</span>
        </h1>
        <p className="text-white/60 mt-6">Cette page n'existe pas — ou plus.</p>
        <Link to="/" data-testid="not-found-home-btn" className="btn-gold mt-10 inline-flex">
          <ArrowLeft size={14} strokeWidth={1.4} /> Retour à l'accueil
        </Link>
      </div>
    </section>
  );
}
